/* TEKTUR satış sayfası davranışları: animasyonların geç yüklenmesi, belirerek gelme,
   yapışkan sipariş çubuğu, duyuru döngüsü ve sipariş kutusu (varyant, adet, hemen al). */
(function () {
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var ticking = false;

  function swapAnim(img) {
    var src = img.getAttribute('data-tk-anim');
    if (!src) return;
    img.removeAttribute('data-tk-anim');
    if (reduceMotion) return;
    var pre = new Image();
    pre.onload = function () { img.src = src; };
    pre.src = src;
  }

  // Görünür alana giren öğeleri kaydırma konumuna göre işler (IntersectionObserver'a bağlı değil).
  function check() {
    ticking = false;
    var vh = window.innerHeight || document.documentElement.clientHeight;
    document.querySelectorAll('.tk-rv:not(.is-in)').forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (reduceMotion || (r.top < vh * 0.94 && r.bottom > 0)) el.classList.add('is-in');
    });
    document.querySelectorAll('img[data-tk-anim]').forEach(function (img) {
      var r = img.getBoundingClientRect();
      if (r.top < vh + 300 && r.bottom > -300) swapAnim(img);
    });
    var bar = document.querySelector('.tk-stick');
    if (bar) {
      var hero = document.querySelector('[data-tk-hero]');
      var offer = document.getElementById('siparis');
      var heroOut = !hero || hero.getBoundingClientRect().bottom < 0;
      var offerIn = false;
      if (offer) { var o = offer.getBoundingClientRect(); offerIn = o.top < vh && o.bottom > 0; }
      bar.classList.toggle('is-on', heroOut && !offerIn);
    }
  }

  function requestCheck() {
    if (ticking) return;
    ticking = true;
    setTimeout(check, 60);
  }

  window.addEventListener('scroll', requestCheck, { passive: true });
  window.addEventListener('resize', requestCheck);
  window.addEventListener('load', check);

  // Kaydırma olayı gelmeyen ortamlar için yedek: her şey göründüğünde durur.
  var safety = setInterval(function () {
    check();
    if (!document.querySelector('.tk-rv:not(.is-in), img[data-tk-anim]')) clearInterval(safety);
  }, 800);

  function initBar() {
    document.querySelectorAll('[data-tk-bar]').forEach(function (bar) {
      var items = bar.querySelectorAll('.tk-bar__item');
      if (!items.length || bar.dataset.tkReady) return;
      bar.dataset.tkReady = '1';
      var i = 0;
      items[0].classList.add('is-on');
      if (items.length < 2) return;
      setInterval(function () {
        items[i].classList.remove('is-on');
        i = (i + 1) % items.length;
        items[i].classList.add('is-on');
      }, 4000);
    });
  }

  function money(cents, format) {
    format = format || '{{amount_with_comma_separator}} TL';
    function fmt(decimals, thousands, decimal) {
      var parts = (cents / 100).toFixed(decimals).split('.');
      var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts[1] ? whole + decimal + parts[1] : whole;
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return fmt(0, ',', '.');
        case 'amount_with_comma_separator': return fmt(2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmt(2, "'", '.');
        case 'amount_no_decimals_with_space_separator': return fmt(0, ' ', ',');
        case 'amount_with_space_separator': return fmt(2, ' ', ',');
        default: return fmt(2, ',', '.');
      }
    });
  }

  function initOffer(box) {
    if (!box || box.dataset.tkReady) return;
    box.dataset.tkReady = '1';
    var form = box.querySelector('form[data-tk-form]');
    var dataEl = box.querySelector('script[data-tk-variants]');
    var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
    var moneyFormat = box.dataset.moneyFormat;
    var idInput = form && form.querySelector('[name="id"]');
    var qtyInput = box.querySelector('[data-tk-qty]');
    var mainImg = box.querySelector('[data-tk-main]');
    var errorEl = box.querySelector('[data-tk-error]');
    var strings = { add: box.dataset.strAdd, soldOut: box.dataset.strSoldout, buy: box.dataset.strBuy, unavailable: box.dataset.strUnavailable };

    box.querySelectorAll('[data-tk-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var v = parseInt(qtyInput.value, 10) || 1;
        v = Math.max(1, Math.min(99, v + parseInt(btn.dataset.tkStep, 10)));
        qtyInput.value = v;
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    box.querySelectorAll('[data-tk-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!mainImg) return;
        mainImg.src = btn.dataset.tkThumb;
        if (btn.dataset.tkSrcset) mainImg.srcset = btn.dataset.tkSrcset; else mainImg.removeAttribute('srcset');
        box.querySelectorAll('[data-tk-thumb]').forEach(function (b) { b.setAttribute('aria-current', b === btn ? 'true' : 'false'); });
      });
    });

    function selectedOptions() {
      var opts = [];
      box.querySelectorAll('[data-tk-option]').forEach(function (fs) {
        var checked = fs.querySelector('input:checked');
        opts[parseInt(fs.dataset.tkOption, 10)] = checked ? checked.value : null;
      });
      return opts;
    }

    function setButtons(variant) {
      box.querySelectorAll('[data-tk-add], [data-tk-buynow]').forEach(function (btn) {
        var label = btn.querySelector('span') || btn;
        var ok = variant && variant.available;
        if (ok) { btn.removeAttribute('disabled'); } else { btn.setAttribute('disabled', 'disabled'); }
        if (btn.hasAttribute('data-tk-add')) label.textContent = ok ? strings.add : (variant ? strings.soldOut : strings.unavailable);
        if (btn.hasAttribute('data-tk-buynow')) label.textContent = ok ? strings.buy : (variant ? strings.soldOut : strings.unavailable);
      });
    }

    function updatePrices(variant) {
      document.querySelectorAll('[data-tk-price]').forEach(function (el) { el.textContent = money(variant.price, moneyFormat); });
      document.querySelectorAll('[data-tk-compare]').forEach(function (el) {
        var show = variant.compare_at_price && variant.compare_at_price > variant.price;
        el.textContent = show ? money(variant.compare_at_price, moneyFormat) : '';
        el.hidden = !show;
      });
      document.querySelectorAll('[data-tk-saving]').forEach(function (el) {
        var show = variant.compare_at_price && variant.compare_at_price > variant.price;
        if (show) {
          var pct = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
          el.textContent = (el.dataset.tpl || '%[pct] indirim').replace('[pct]', pct);
        }
        el.hidden = !show;
      });
    }

    box.querySelectorAll('[data-tk-option] input').forEach(function (input) {
      input.addEventListener('change', function () {
        var opts = selectedOptions();
        var variant = variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); });
        if (variant) {
          idInput.value = variant.id;
          updatePrices(variant);
          if (variant.featured_image && mainImg) { mainImg.src = variant.featured_image; mainImg.removeAttribute('srcset'); }
        }
        setButtons(variant);
      });
    });

    var buyBtn = box.querySelector('[data-tk-buynow]');
    if (buyBtn && form) {
      buyBtn.addEventListener('click', function () {
        if (buyBtn.hasAttribute('disabled')) return;
        if (errorEl) errorEl.hidden = true;
        buyBtn.classList.add('loading');
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(idInput.value, 10), quantity: parseInt(qtyInput.value, 10) || 1 }] })
        })
          .then(function (r) {
            return r.json().catch(function () { return {}; }).then(function (j) { return { ok: r.ok, body: j }; });
          })
          .then(function (res) {
            if (!res.ok) throw new Error(res.body.description || res.body.message || '');
            window.location.href = root + 'checkout';
          })
          .catch(function (err) {
            buyBtn.classList.remove('loading');
            if (errorEl) { errorEl.textContent = err.message || box.dataset.strError; errorEl.hidden = false; }
          });
      });
    }
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-tk-offer]').forEach(initOffer);
    check();
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
    initBar();
  });

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
    initBar();
  });
})();
